function removeFOUC() {
    $('.barba-container, .footer-navigation').addClass('in');
    $('body').scrollTop(0);
}

function changeNavigation() {
    var siteRoot = location.protocol + '//' + window.location.host + '/',
        siteUrl = window.location.href;

    if (siteRoot === siteUrl) {
        $('.only-on-homepage').removeClass('hide');
        $('.navbar-brand').prop('href','#');
    }

    $('a').not('[href*="tel:"], [href*="mailto:"], [href*="javascript:"], [href*="#"]').each(function () {
        var isInternalLink = new RegExp('/' + window.location.host + '/');
        if ( ! isInternalLink.test(this.href) ) {
            $(this).prop('target', '_blank').prop('rel', 'noopener');
        }
    });
}

function initializeTooltips() {
    $('[data-toggle="tooltip"]').tooltip();
}

function initializePopovers() {
    $('[data-toggle="popover"]').popover({
        html: true
    });
}

function initializeResponsivePagination() {
    $('.pagination').rPage();
}

function initializeShareButton() {
    var shareButton = new ShareButton(
        config = {
            ui: {
                flyout: 'sb-bottom sb-left',
                buttonText: '<svg class="svg svg-icon-share"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-share"></use></svg> Share'
            },
            networks: {
                facebook: {
                    app_id: '744869262310927'
                },
                email: {
                    enabled: false
                },
                reddit: {
                    enabled: false
                }
            }
        });
}

function showHideSidebarToggle() {
        $('body').removeClass('sidebar-top');
        $('.navbar-right .right-sidebar-toggle, .right-sidebar-toggle-bottom').toggleClass('active');
        if ($('body').hasClass('sidebar-open')) {
            $('#right-sidebar').animateCss('slideOutRight');
        } else {
            $('#right-sidebar, .sidebar-overlay .svg').animateCss('slideInRight');
        }
        $('body').toggleClass('sidebar-open');    
}
function showHideSidebar() {
    $('.right-sidebar-toggle, .sidebar-overlay, .right-sidebar-toggle-bottom').click(function() {
        showHideSidebarToggle();
    });

    $('.right-sidebar-toggle-bottom').click(function() {
        $('body').toggleClass('sidebar-top');
    });
    $('.footer-navigation [data-toggle="dropdown"]').click(function() {
        $('body').removeClass('sidebar-top');
    });
}

function changeCurrency() {
    $('.select-currency').click(function() {
        setSelectedCurrency($(this).text());
    });
}

function webAppView() {
    if (window.navigator.standalone === true) {
        $('.history-buttons').removeClass('hide');
        $('body').addClass('standalone');
        $('#right-sidebar').css('top', '80px');
        $('#page-wrapper').css('margin-top', '80px');
        $('#right-sidebar,.navbar-fixed-top').css('top', '20px');
    }

    function isRunningStandalone() {
        return (window.matchMedia('(display-mode: standalone)').matches);
    }
    if (isRunningStandalone()) {
        $('.history-buttons').removeClass('hide');
    }

    if (window.navigator.standalone === true) {
        $('.history-buttons').removeClass('hide');
        $('#right-sidebar').css('top', '80px');
        $('#page-wrapper').css('margin-top', '80px');
        $('#right-sidebar,.navbar-fixed-top').css('top', '20px');
    }
}

function initializeNavigation() {
    removeFOUC(); //Change opacity of #page-wrapper from 0 to 1 when jQuery and css are loaded to eliminate FOUC
    changeNavigation(); //Hide navigation elements visible only on homepage/root
    webAppView(); //Change margins and show buttons if site is on web app view on iOS or Android
    initializeTooltips(); //Start Bootstrap tooltips
    initializePopovers(); //Start Bootstrap popovers
    showHideSidebar(); //Toggle options for right sidebar
    initializeResponsivePagination(); //Start pagination responsiveness
    if (!(browser.isIe() && browser.getVersion() <= 9)) {
        initializeShareButton(); //Start social share button
    }
    changeCurrency(); //Change site currency
}
